import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import store from 'dashboard/store';
import ChannelFactory from './ChannelFactory.vue';

import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';
import InboxHome from './Index.vue';
import Settings from './Settings.vue';
import InboxChannel from './InboxChannels.vue';
import ChannelList from './ChannelList.vue';
import { canaisOferecidos } from './canaisOferecidos';
import AddAgents from './AddAgents.vue';
import FinishSetup from './FinishSetup.vue';

// ACESSO-01 (L8b): criar, editar e apagar caixas e escolher quem atende nelas (`inboxes#create`, `#update`,
// `inbox_members#*`).
const ESCOPOS_DAS_CAIXAS = ['inboxes:manage'];

// O Site só aparece para o super admin. O usuário sai da store como no guard de
// `routes/index.js` (`type`), e já está carregado aqui: o `beforeEach` global espera o
// `setUser` antes de qualquer `beforeEnter`.
const canaisDoUsuario = () =>
  canaisOferecidos(store.getters.getCurrentUser?.type === 'SuperAdmin');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_inbox_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_inbox_list',
          component: InboxHome,
          meta: {
            featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
            permissions: ['administrator', 'inbox_manage'],
            escopos: ESCOPOS_DAS_CAIXAS,
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingsContent,
      props: params => {
        const showBackButton = params.name !== 'settings_inbox_list';
        const fullWidth = params.name === 'settings_inbox_show';
        return {
          headerTitle: 'INBOX_MGMT.HEADER',
          icon: 'mail-inbox-all',
          showBackButton,
          fullWidth,
        };
      },
      children: [
        {
          path: 'new',
          component: InboxChannel,
          children: [
            {
              path: '',
              name: 'settings_inbox_new',
              component: ChannelList,
              // Redirecionar no guard SUBSTITUI a entrada do histórico: o "Anterior" (que é
              // `router.go(-1)`) volta para a lista de caixas, e não para cá, que mandaria de novo.
              beforeEnter: to => {
                const canais = canaisDoUsuario();
                return canais.length === 1
                  ? {
                      name: 'settings_inboxes_page_channel',
                      params: { ...to.params, sub_page: canais[0] },
                    }
                  : true;
              },
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator', 'inbox_manage'],
                escopos: ESCOPOS_DAS_CAIXAS,
              },
            },
            {
              path: ':inbox_id/finish',
              name: 'settings_inbox_finish',
              component: FinishSetup,
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator', 'inbox_manage'],
                escopos: ESCOPOS_DAS_CAIXAS,
              },
            },
            {
              path: ':sub_page',
              name: 'settings_inboxes_page_channel',
              component: ChannelFactory,
              beforeEnter: to =>
                canaisDoUsuario().includes(to.params.sub_page) || {
                  name: 'settings_inbox_new',
                  params: { accountId: to.params.accountId },
                },
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator', 'inbox_manage'],
                escopos: ESCOPOS_DAS_CAIXAS,
              },
              props: route => {
                return { channelName: route.params.sub_page };
              },
            },
            {
              path: ':inbox_id/agents',
              name: 'settings_inboxes_add_agents',
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator', 'inbox_manage'],
                escopos: ESCOPOS_DAS_CAIXAS,
              },
              component: AddAgents,
            },
          ],
        },
        {
          path: ':inboxId/:tab?',
          name: 'settings_inbox_show',
          component: Settings,
          meta: {
            featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
            permissions: ['administrator', 'inbox_manage'],
            escopos: ESCOPOS_DAS_CAIXAS,
          },
        },
      ],
    },
  ],
};
